export default __webpack_public_path__ + "static/media/VectorDark.6f7ecce4.svg";